import { styled } from '@zenbusiness/zui/styles';

export const IconBorderStyle = ({ theme, disabled, circle }) => ({
  border: `1px solid ${disabled ? theme.palette.text.tertiary : theme.palette.border.main}`,
  backgroundColor: `${disabled ? theme.palette.background.grey.main : theme.palette.common.black}`,
  borderRadius: `${circle ? '100%' : '10px'}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 auto',
  overflowY: 'auto',
  width: '40px',
  height: '40px',
  [theme.breakpoints.up('md')]: {
    width: '44px',
    height: '44px',
    borderRadius: `${circle ? '100%' : '12px'}`
  }
});

export const IconBorderStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'circle'
})(IconBorderStyle);
